import React from 'react'
import { Avatar } from '@components/Avatar/Avatar'
import { MutualTowns } from '@components/MutualTowns/MutualTowns'
import { TipCounter } from '@components/TipCounter/TipCounter'
import { UserRankBadge } from '@components/UserRankBadge/UserRankBadge'
import { UserRolePills } from '@components/UserRoles/UserRoles'
import { Icon, Stack } from '@ui'
import { useGetUserBio } from 'hooks/useUserBio'
import { Paragraph } from 'ui/components/Text/Paragraph'
import { Tooltip } from 'ui/components/Tooltip/Tooltip'
import { useSpaceId, useUserLookupContext } from 'use-towns-client'

type Props = {
    userId: string
}

export const ProfileHoverCard = (props: Props) => {
    const { userId } = props
    const { lookupUser } = useUserLookupContext()
    const user = lookupUser(userId)
    const { data: userBio } = useGetUserBio(userId)
    const spaceId = useSpaceId()
    const ensName = user?.ensName

    const userRoles = spaceId ? <UserRolePills userId={userId} spaceId={spaceId} /> : null
    const displayName = ensName || user?.displayName || user?.username || ''
    const username = user?.username || ''
    return user ? (
        <Tooltip gap elevate maxWidth="300">
            <Stack gap padding="sm">
                <Stack horizontal gap>
                    <Avatar userId={userId} size="avatar_lg" />

                    <Stack justifyContent="center" gap="sm">
                        {!!displayName && (
                            <Stack horizontal gap="xs" alignItems="center" height="x1.5">
                                <Paragraph truncate strong color="default">
                                    {displayName}
                                </Paragraph>
                                {user.isBot && <Icon type="robot" size="square_xs" color="gray2" />}
                                <TipCounter userId={user.userId} />
                            </Stack>
                        )}

                        {!!username && (
                            <Stack horizontal gap="xxs" alignItems="center">
                                <Paragraph truncate color="gray2">
                                    @{username}
                                </Paragraph>
                            </Stack>
                        )}
                    </Stack>
                </Stack>
                {user && (
                    <Stack horizontal gap="xs" color="gray1" alignItems="center" paddingX="sm">
                        <MutualTowns userId={user.userId} />
                    </Stack>
                )}
                {userBio && (
                    <Stack gap="sm">
                        <Paragraph strong size="md">
                            Bio
                        </Paragraph>
                        <Paragraph size="md" color="gray2">
                            {userBio}
                        </Paragraph>
                    </Stack>
                )}
                {userRoles && (
                    <Stack gap="sm">
                        <Paragraph strong>Roles</Paragraph>
                        <Stack>{userRoles}</Stack>
                    </Stack>
                )}
                {userId && <UserRankBadge targetUserId={userId} />}
            </Stack>
        </Tooltip>
    ) : (
        <Tooltip>User info not available</Tooltip>
    )
}
